import React, { Component } from "react";
import {
  mode,
  profile,
  alert,
  float,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DateRangePicker,
  Select,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  XLSX,
  saveAs,
  StatusTnx,
  linkRole,
  writeClipboard,
  StatusIcon,
  StatusReason,
  isExpiredCancel,
  CopyCell,
  captureShareImage,
  sendShareToTelegram,
  downloadShareImage,
  getShareTitle,
  StatusTnxShare,
  maskAccount,
} from "../../components/CustomComponent.js";
import { NumericFormat } from "react-number-format";

import { GATEWAY_LOGO, gateway_logo_background } from "../../components/GatewayLogo.js";

import LOGO512 from "../../assets/images/logo512.png";
import WATERMARK from "../../assets/images/watermark.png";

import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";

const countdownInitial = 60;

// every column of the transaction table, in render order. the column manager
// builds its checkbox list straight from this, so adding a column here is
// enough for it to show up in the menu.
const columnDefs = () => [
  { key: "time", label: "Time" },
  { key: "ref_no", label: "RefNo" },
  {
    key: "ref_qr",
    label: params("type") === "deposits" ? "RefQR" : "RefPayout",
  },
  ...(profile?.user_type === "super_user"
    ? [{ key: "gateway", label: "Gateway" }]
    : []),
  { key: "customer", label: "Customer" },
  { key: "bank", label: "Bank" },
  { key: "amount", label: "Amount" },
  { key: "fee_rate", label: "Fee%" },
  { key: "fee", label: "Fee" },
  { key: "vat", label: "VAT" },
  { key: "amount_net", label: "Amount Net" },
  { key: "process", label: "Process" },
  { key: "status", label: "Status" },
  { key: "callback", label: "Callback" },
  { key: "actions", label: "Actions" },
];

const columnStorageKey = () => `columns-${params("type") || "deposits"}`;

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const pageSizeStorageKey = () => `page-size-${params("type") || "deposits"}`;

const loadPageSize = () => {
  const saved = Number(localStorage.getItem(pageSizeStorageKey()));
  return PAGE_SIZE_OPTIONS.includes(saved) ? saved : 10;
};

const loadColumns = () => {
  const columns = {};
  columnDefs().forEach((column) => {
    columns[column.key] = true;
  });
  try {
    const saved = JSON.parse(localStorage.getItem(columnStorageKey()) || "{}");
    Object.keys(columns).forEach((key) => {
      if (typeof saved[key] === "boolean") columns[key] = saved[key];
    });
  } catch (e) {}
  return columns;
};

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_create: false,
      modal_update: false,
      modal_update_datetime: false,
      modal_detail: false,
      modal_mismatch: false,

      columns: loadColumns(),
      page: 1,
      page_size: loadPageSize(),
      table_updated_at: "",
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,
      show_full: false,

      // SEARCH
      filter_status: params("status") || "",
      // arriving from a ref_no / uid link is a lookup of one known transaction,
      // so start with no date range or the default 3-day window hides it
      filter_start_date:
        params("ref_no") || params("uid")
          ? ""
          : format_date(
              new Date(new Date().setDate(new Date().getDate() - 3)),
              "yyyy-mm-dd",
              "en",
            ),
      filter_end_date:
        params("ref_no") || params("uid")
          ? ""
          : format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_data_search: params("ref_no") || "",
      filter_uid: params("uid") || "",
      filter_search_mode: params("uid") ? "uid" : "general",
      filter_process_type: "",
      filter_currency: "THB",
      filter_broker: "",

      // EXPORT
      export_date: "",

      // LIST
      data: [],
      loaded: false,
      count: 10,
      data_broker: [],
      data_customer: [],
      data_bank: [],
      data_bank_payout: [],
      data_bank_payout_lak: [],

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      is_topup: false,
      is_hq: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      status_reason: null,
      broker: null,
      customer: null,
      ref_no_refund: "",

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",

      mismatch_bank_code: "",
      mismatch_bank_account_number: "",
      mismatch_bank_account_name_th: "",
      mismatch_bank_account_name_en: "",

      select: -1,
      hover_index: -1,
      hover_info_index: -1,
      hover_monitor_card: "",
      inline_help_popup: null,
      pending_monitor: {
        total_pending: 0,
        over_20_minutes: 0,
        within_20_minutes: 0,
        updated_at: "-",
      },
      pending_auto_refresh_enabled: false,
      pending_auto_refresh_countdown: countdownInitial,

      modal_share: false,
      share_image: null,
      chat_id: ""
    };
    this.pendingAutoRefreshInterval = null;
    this.tableRefreshInterval = null;
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }

  componentWillUnmount() {
    this.StopPendingAutoRefresh();
    this.StopTableAutoRefresh();
  }

  showInlineHelpPopup = (event, popup) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 260;
    const left = Math.min(
      Math.max(rect.left - 8, 16),
      window.innerWidth - popupWidth - 16,
    );
    const top = Math.max(rect.top - 16, 16);

    this.setState({
      inline_help_popup: {
        ...popup,
        left,
        top,
      },
    });
  };

  setPageSize = (page_size) => {
    localStorage.setItem(pageSizeStorageKey(), String(page_size));
    // page 1 again: the row the user was looking at lands somewhere else once
    // the page size changes, so keeping the page number would be misleading
    this.setState({ page_size }, () => {
      this.Get(1);
    });
  };

  resetColumns = () => {
    localStorage.removeItem(columnStorageKey());
    this.setState({ columns: loadColumns() });
  };

  StartTableAutoRefresh = () => {
    if (this.tableRefreshInterval) return;

    this.setState({
      table_auto_refresh: true,
      table_refresh_countdown: countdownInitial,
    });

    this.tableRefreshInterval = setInterval(async () => {
      const { table_auto_refresh, table_refresh_countdown, page } = this.state;

      if (!table_auto_refresh) return;

      if (table_refresh_countdown <= 1) {
        // silent + current page: refreshing must not steal the row the user
        // is reading or flash the full-screen loader
        await this.Get(page, { silent: true });
        this.setState({ table_refresh_countdown: countdownInitial });
        return;
      }

      this.setState({
        table_refresh_countdown: table_refresh_countdown - 1,
      });
    }, 1000);
  };

  StopTableAutoRefresh = () => {
    if (this.tableRefreshInterval) {
      clearInterval(this.tableRefreshInterval);
      this.tableRefreshInterval = null;
    }

    this.setState({
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,
    });
  };

  ToggleTableAutoRefresh = () => {
    if (this.state.table_auto_refresh) {
      this.StopTableAutoRefresh();
      return;
    }

    this.StartTableAutoRefresh();
  };

  isColumn = (key) => this.state.columns?.[key] !== false;

  toggleColumn = (key) => {
    this.setState((prevState) => {
      const columns = { ...prevState.columns, [key]: !prevState.columns[key] };
      localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
      return { columns };
    });
  };

  toggleAllColumns = (checked) => {
    const columns = {};
    columnDefs().forEach((column) => {
      columns[column.key] = checked;
    });
    localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
    this.setState({ columns });
  };

  hideInlineHelpPopup = () => {
    this.setState({ inline_help_popup: null });
  };

  copyInlineHelpText = async (text) => {
    if (!(await writeClipboard(text))) return;
    this.setState((prevState) =>
      prevState.inline_help_popup
        ? {
            inline_help_popup: {
              ...prevState.inline_help_popup,
              copied: true,
            },
          }
        : null,
    );
  };

  setSearchMode = (mode) => {
    this.setState((prevState) => ({
      filter_search_mode: mode,
      filter_data_search:
        mode === "general" ? prevState.filter_data_search : "",
      filter_uid: mode === "uid" ? prevState.filter_uid : "",
    }));
  };

  normalizeTransactionListResponse = (result) => {
    const rows = Array.isArray(result?.data)
      ? result.data
      : result?.data
        ? [result.data]
        : [];

    return {
      rows,
      count: typeof result?.count === "number" ? result.count : rows.length,
    };
  };

  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker, data_bank, data_bank_payout, data_bank_payout_lak;
    let [result_broker, result_bank] = await Promise.all([
      GET("v1/admin/brokers/options", {
        page_size: 100,
        page: 0,
        data_search: "",
      }),
      GET("v1/admin/banks", { page_size: 100, page: 0, data_search: "" }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
      }));
    }
    if (result_bank?.status) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      data_bank = result_bank.data
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.code,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(
                `../../assets/images/bank/${
                  global.bank.find((b) => b.value === e.code)?.icon ||
                  "bank.png"
                }`,
              )}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
        }));
      data_bank_payout = result_bank.data.filter(e=>e.bank_gateway_mappings.some((mapping) => mapping.gateway === "spark"))
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.bank_gateway_mappings.find((mapping) => mapping.gateway === "spark").bank_uid,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(
                `../../assets/images/bank/${
                  global.bank.find((b) => b.value === e.code)?.icon ||
                  "bank.png"
                }`,
              )}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
        }));
      data_bank_payout_lak = result_bank.data.filter(e=>e.bank_gateway_mappings.some((mapping) => mapping.gateway === "uniqpay"))
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.bank_gateway_mappings.find((mapping) => mapping.gateway === "uniqpay").bank_code,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(
                `../../assets/images/bank/${
                  global.bank.find((b) => b.value === e.code)?.icon ||
                  "bank.png"
                }`,
              )}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
        }));
    }
    this.setState({
      data_broker,
      data_bank,
      data_bank_payout,
      data_bank_payout_lak,
    });
  };
  Get = async (page, options = {}) => {
    const { silent = false } = options;
    const {
      filter_search_mode,
      filter_data_search,
      filter_uid,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_process_type,
      filter_currency,
      filter_broker,
    } = this.state;
    let data, count, pending_monitor;
    if (!silent) {
      loading(true);
    }
    // let _filter_start_date = filter_start_date;
    // let _filter_end_date = filter_end_date;

    // if(!filter_start_date && !filter_data_search && !filter_status && !filter_process_type && !filter_broker){
    //     _filter_start_date = format_date(new Date(new Date().setDate(new Date().getDate() - 3)), "yyyy-mm-dd", "en");
    // }
    // if(!filter_end_date && !filter_data_search && !filter_status && !filter_process_type && !filter_broker){
    //     _filter_end_date = format_date(new Date(), "yyyy-mm-dd", "en");
    // }

    // เปลี่ยนหน้า 1 ครั้ง = 2 request: แถวของหน้านั้น + ตัวเลขการ์ด pending ที่ DB นับให้แล้ว
    // dropdown broker/bank ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ โหลดครั้งเดียวใน GetMaster
    let [result, result_pending_summary] = await Promise.all([
      GET(`transactions/${params("type")}/list`, {
        page_size: this.state.page_size,
        page: page,
        uid: filter_search_mode === "uid" ? filter_uid : "",
        data_search:
          filter_search_mode === "general" ? filter_data_search : "",
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: filter_status,
        process_type: filter_process_type,
        currency: filter_currency,
        broker_id: filter_broker,
        is_hq: false,
      }),
      GET(`transactions/${params("type")}/pending-summary`, {
        currency: filter_currency,
        broker_id: filter_broker,
      }),
    ]);
    if (result?.status) {
      const normalizedResult = this.normalizeTransactionListResponse(result);
      data = normalizedResult.rows;
      count = normalizedResult.count;
    }
    if (result_pending_summary?.status && result_pending_summary.data) {
      const summary = result_pending_summary.data;
      pending_monitor = {
        total_pending: Number(summary.total_pending) || 0,
        over_20_minutes: Number(summary.over_20_minutes) || 0,
        within_20_minutes: Number(summary.within_20_minutes) || 0,
        updated_at: format_date(new Date(), "dd/mm/yy hh:mm", "en"),
      };
    }
    this.setState({
      data,
      loaded: true,
      count,
      page: page || 1,
      table_updated_at: format_date(new Date(), "hh:mm:ss", "en"),
      pending_monitor: pending_monitor || {
        total_pending: 0,
        over_20_minutes: 0,
        within_20_minutes: 0,
        updated_at: "-",
      },
      select: silent ? this.state.select : -1,
    });
    if (!silent) {
      loading(false);
    }
  };
  GetCustomer = async (data_search = "") => {
    const { currency, broker_id } = this.state;
    let data_customer;
    let [result_customer] = await Promise.all([
      GET("v1/admin/customers", {
        page_size: 100,
        page: 0,
        data_search: data_search,
        currency: currency,
        broker_id: broker_id,
      }),
    ]);
    if (result_customer?.status) {
      data_customer = result_customer?.data.map((e) => ({
        value: e.uid,
        label: `${e.name_en || e.name_th || "-"}${
          e.bank_account_number ? ` (${maskAccount(e.bank_account_number)})` : ""
        }`,
        front: (
          <img
            alt="bank"
            src={require(
              `../../assets/images/bank/${
                global.bank.find((b) => b.value === e.bank_code)?.icon ||
                "bank.png"
              }`,
            )}
            width={18}
            height={18}
            style={{ marginRight: 6 }}
          />
        ),
        bank_code: e.bank_code,
        bank_account_name_th: e.bank_account_name_th,
        bank_account_name_en: e.bank_account_name_en,
        bank_account_number: e.bank_account_number,
        broker: e.broker?.uid || "",
        currency: e.currency || "THB",
      }));
    }
    this.setState({
      data_customer,
    });
  };
  Create = async () => {
    const {
      broker_id,
      customer_id,
      ref_no,
      amount,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      currency,
      is_topup,
    } = this.state;

    if (!broker_id.trim()) {
      alert("", "warning", "Warning", "Please select Broker");
      return;
    } else if (!ref_no.trim()) {
      alert("", "warning", "Warning", "Please input Ref No");
      return;
    } else if (!amount.trim()) {
      alert("", "warning", "Warning", "Please input Amount");
      return;
    }
    if (!customer_id && !is_topup) {
      alert("", "warning", "Warning", "Please select customer");
      return;
    }

    let body = {
      broker_id,
      customer_id,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      ref_no,
      amount: Number(amount),
      currency: currency || "THB",
      is_topup: is_topup || false,
      is_hq: false,
    };
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await POST(`transactions/${params("type")}/create`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  Update = async (is_approved_auto) => {
    const { uid, fee_type, fee_rate, is_vat, status, is_usdt } = this.state;
    // fee_type / fee_rate are nullable in the DB (and fee_rate may arrive as a
    // number); calling .trim() on them directly threw inside the setState
    // callback and made Approve / Reject from the row menu fail silently
    if (!String(fee_type ?? "").trim()) {
      alert("", "warning", "Warning", "Please select Fee Rate Type");
      return;
    } else if (!String(fee_rate ?? "").trim()) {
      alert("", "warning", "Warning", "Please input Fee Rate");
      return;
    }
    if (["cancel", "success"].includes(status)) {
      Swal.fire({
        title: "Confirm",
        text: `Do you want to ${
          status === "cancel" ? "Reject" : "Approve"
        } the transaction?`,
        icon: "info",
        input: "textarea",
        inputPlaceholder: "Enter remark...",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
        color: mode === "dark" ? "#fff" : "#000000", // Text color
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
      }).then(async (re) => {
        if (re.isConfirmed) {
          const remark = re.value;
          loading(true);
          let body = {
            fee_type,
            fee_rate: Number(fee_rate),
            is_vat,
            status,
            is_usdt,
            remark,
            is_approved_auto: is_approved_auto || false,
          };
          let result = await PUT(
            `transactions/${params("type")}/update/` + uid,
            body,
          );
          if (result?.status) {
            // alert("#", "success");
            alert(
              "",
              "success",
              "Success",
              "Transaction updated successfully.",
            );
            this.Get(1);
            this.setState({
              modal_create: false,
              modal_update: false,
              modal_detail: false,
            });
          } else {
            alert(
              "",
              "warning",
              "Warning",
              result?.message || "An error occurred. Please try again.",
            );
          }
          loading(false);
        }
      });
    } else {
      if (
        await alert(
          "",
          "info",
          "Confirm",
          "Do you want to confirm the submission?",
          "Confirm",
          "Cancel",
        )
      ) {
        loading(true);
        let body = {
          fee_type,
          fee_rate: Number(fee_rate).toFixed(4),
          is_vat,
          status,
          is_usdt,
          is_approved_auto: is_approved_auto || false,
        };
        let result = await PUT(
          `transactions/${params("type")}/update/` + uid,
          body,
        );
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again.",
          );
        }
        loading(false);
      }
    }
  };
  UpdateDateTime = async () => {
    const { uid, created_at } = this.state;
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let body = {
        created_at: format_date(created_at, "yyyy-mm-dd hh:mm:ss", "en"),
      };
      console.log("body", body);
      let result = await PUT(`v1/admin/transactions/disbursed-at/` + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };

  UpdateMismatch = async () => {
    const { uid, mismatch_bank_code, mismatch_bank_account_number, mismatch_bank_account_name_th, mismatch_bank_account_name_en } = this.state;
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let body = {
        mismatch_bank_code,
        mismatch_bank_account_number,
        mismatch_bank_account_name_th,
        mismatch_bank_account_name_en,
      };
      console.log("body", body);
      let result = await PUT(`v1/admin/transactions/convert-mismatch/` + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        "Do you really want to delete this item?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await DELETE(
        `transactions/${params("type")}/delete/` + id,
        null,
      );
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  ReWithdrawal = async () => {
    const { uid } = this.state;
    Swal.fire({
      title: "Confirm",
      text: `Do you want to "withdrawal" again?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
      color: mode === "dark" ? "#fff" : "#000000", // Text color
      confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
      cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
    }).then(async (re) => {
      if (re.isConfirmed) {
        loading(true);
        let body = { uid };
        let result = await POST(`transactions/withdrawals/re-order`, body);
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again.",
          );
        }
        loading(false);
      }
    });
  };
  calDetail = async () => {
    const { fee_type, fee_rate, is_vat, amount, cost_gateway } = this.state;
    if (params("type") === "deposit") {
      const _amount = Number(amount);
      const _fee =
        fee_type === "fixed"
          ? Number(fee_rate)
          : Number((_amount * (Number(fee_rate) / 100)).toFixed(4));
      const _vat = Number((_fee * 0.07).toFixed(4));
      const amountAfterFee = _amount - _fee;
      let amountNet = is_vat
        ? Number((amountAfterFee - _vat - Number(cost_gateway)).toFixed(4))
        : Number(amountAfterFee.toFixed(4));

      this.setState({
        fee: _fee.toFixed(4),
        amount_net: amountNet.toFixed(4),
        vat: is_vat ? _vat.toFixed(4) : "00.00",
      });
    } else {
      const _amount = Number(amount);
      const _fee =
        fee_type === "fixed"
          ? Number(fee_rate)
          : Number((_amount * (Number(fee_rate) / 100)).toFixed(4));
      const _vat = Number((_fee * 0.07).toFixed(4));
      const amountAfterFee = _amount + _fee;
      let amountNet = is_vat
        ? Number((amountAfterFee + _vat + Number(cost_gateway)).toFixed(4))
        : Number(amountAfterFee.toFixed(4));

      this.setState({
        fee: _fee.toFixed(4),
        amount_net: amountNet.toFixed(4),
        vat: is_vat ? _vat.toFixed(4) : "00.00",
      });
    }
  };
  ExportCSV = async () => {
    const {
      filter_search_mode,
      filter_data_search,
      filter_uid,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_process_type,
      filter_broker,
    } = this.state;
    
    loading(true);

    try {
      // 1. กำหนด Start Date และ End Date เพื่อใช้สำหรับวนลูป
      const startDateObj = filter_start_date
        ? new Date(filter_start_date)
        : new Date(new Date().getFullYear(), new Date().getMonth(), 1);

      const endDateObj = filter_end_date
        ? new Date(filter_end_date)
        : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

      // 2. สร้าง Array ของวันที่ทั้งหมด (เช่น ['2026-04-01', '2026-04-02', ...])
      const dateList = [];
      let currentDate = new Date(startDateObj);
      while (currentDate <= endDateObj) {
        // ใช้ format_date ของคุณ เพื่อแปลงเป็น string "yyyy-mm-dd" ไว้รอยิง API
        dateList.push(format_date(new Date(currentDate), "yyyy-mm-dd", "en"));
        currentDate.setDate(currentDate.getDate() + 1); // บวกเพิ่มทีละ 1 วัน
      }

      let all_data_transaction = []; // ตัวแปรสำหรับเก็บข้อมูลรวม
      const BATCH_SIZE = 3; // กำหนดจำนวน API ที่จะยิงพร้อมกัน

      // 3. วนลูปยิง API เป็น Batch ทีละ 3 วัน
      for (let i = 0; i < dateList.length; i += BATCH_SIZE) {
        // หั่น Array มาทีละ 3 วัน
        const batchDates = dateList.slice(i, i + BATCH_SIZE);

        // สร้าง Array ของ Promise
        const batchPromises = batchDates.map((dateStr) => {
          return GET(`transactions/${params("type")}/list`, {
            page_size: 100000,
            page: 0,
            uid: filter_search_mode === "uid" ? filter_uid : "",
            data_search: filter_search_mode === "general" ? filter_data_search : "",
            start_date: dateStr, // ใช้วันเดียว
            end_date: dateStr,   // ใช้วันเดียว
            filter_status: filter_status || "success",
            process_type: filter_process_type,
            currency: "",
            broker_id: filter_broker,
            is_hq: false,
          });
        });

        // รอจนกว่าจะยิงเสร็จทั้ง 3 วัน
        const results = await Promise.all(batchPromises);

        // 4. นำผลลัพธ์ของแต่ละวันมารวมกัน
        for (const result of results) {
          if (result?.status) {
            const { rows: data_transaction } = this.normalizeTransactionListResponse(result);
            all_data_transaction = all_data_transaction.concat(data_transaction);
          }
        }
      }

      // 5. ถ้ามีข้อมูล ค่อยออก Report (รูปแบบเหมือนเดิม)
      if (all_data_transaction.length > 0) {
        // EXPORT CSV
        const json_data = all_data_transaction.map((item) => ({
          time: format_date(item.created_at, "dd/mm/yy hh:mm", "en"),
          "Ref No": item.ref_no,
          RefQR: item.reference_id,
          Gateway: item.gateway,
          Broker: item.broker?.name_en || "-",
          Customer: item.customer?.name_en || "-",
          Amount: toFixed(item.amount, 2),
          Fee: toFixed(item.fee, 2),
          "VAT Type": item.is_vat ? "VAT" : "NO VAT",
          VAT: item.is_vat ? toFixed(item.vat, 2) : "-",
          "Amount Net": toFixed(item.amount_net, 2),
          Process:
            item.process_type === "manual"
              ? "Manual"
              : item.process_type === "auto"
                ? "Auto"
                : "-",
          Status: item.ref_no_refund ? "refund" : item.status || "-",
          Remark: item.remark,
          currency: item.currency,
        }));

        // 1. Convert JSON to worksheet
        const worksheet_thb = XLSX.utils.json_to_sheet(
          json_data.filter((e) => e.currency === "THB"),
        );
        const worksheet_lak = XLSX.utils.json_to_sheet(
          json_data.filter((e) => e.currency === "LAK"),
        );

        // 2. Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet_thb, "THB");
        XLSX.utils.book_append_sheet(workbook, worksheet_lak, "LAK");

        // 3. Write the workbook to binary buffer
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        // 4. Save to file
        const data = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        saveAs(
          data,
          `${params("type")}-${format_date(startDateObj, "dd/mm/yy", "en")}-${format_date(endDateObj, "dd/mm/yy", "en")}.xlsx`
        );
      } else {
        // (Option) แจ้งเตือนกรณีไม่มีข้อมูลเลย
        console.log("No data found for the selected date range.");
      }

    } catch (error) {
      console.error("Export Error: ", error);
    } finally {
      loading(false);
    }
  };
  Inquiry = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the Inquiry?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      const { uid } = this.state;
      let body = { uid };
      let result = await GET(`transactions/inquiry`, body);
      if (result?.status) {
        alert("", "success");
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  inquiryAll = async () => {
    let result = await GET(`transactions/${params("type")}/list`, {
      page_size: 100000,
      page: 0,
      data_search: "",
      start_date: "",
      end_date: "",
      filter_status: "pending",
      process_type: "",
      currency: "THB",
      broker_id: "",
      is_hq: false,
    });
    console.log("result:", result);
    if (
      await alert(
        "",
        "info",
        "Confirm",
        `Do you want to confirm the Inquiry ${result?.data?.length || 0} transactions?`,
        "Confirm",
        "Cancel",
      )
    ) {
    loading(true);
      const pendingRows = Array.isArray(result?.data) ? result.data : [];
      const concurrency = 5;
      for (let i = 0; i < pendingRows.length; i += concurrency) {
        const batch = pendingRows.slice(i, i + concurrency);
        await Promise.all(
          batch.map((e) => GET(`transactions/inquiry`, { uid: e.uid })),
        );
        // Reduce burst load to avoid DB lock contention on backend.
        await new Promise((resolve) => setTimeout(resolve, 150));
      }
      loading(false);
      alert("#", "success");
    }
  };
  Callback = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the Callback?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      const { uid } = this.state;
      let body = { uid };
      let result = await POST(`callback/re-callback`, body);
      if (result?.status) {
         alert("", "success");
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  StartPendingAutoRefresh = () => {
    if (this.pendingAutoRefreshInterval) return;

    this.setState({
      pending_auto_refresh_enabled: true,
      pending_auto_refresh_countdown: countdownInitial,
    });

    this.pendingAutoRefreshInterval = setInterval(async () => {
      const { pending_auto_refresh_enabled, pending_auto_refresh_countdown } =
        this.state;

      if (!pending_auto_refresh_enabled) return;

      if (pending_auto_refresh_countdown <= 1) {
        await this.Get(1, { silent: true });
        this.setState({ pending_auto_refresh_countdown: countdownInitial });
        return;
      }

      this.setState({
        pending_auto_refresh_countdown: pending_auto_refresh_countdown - 1,
      });
    }, 1000);
  };
  StopPendingAutoRefresh = () => {
    if (this.pendingAutoRefreshInterval) {
      clearInterval(this.pendingAutoRefreshInterval);
      this.pendingAutoRefreshInterval = null;
    }

    this.setState({
      pending_auto_refresh_enabled: false,
      pending_auto_refresh_countdown: countdownInitial,
    });
  };
  TogglePendingAutoRefresh = () => {
    if (this.state.pending_auto_refresh_enabled) {
      this.StopPendingAutoRefresh();
      return;
    }

    this.StartPendingAutoRefresh();
  };
  getPendingMonitorConfig = () => {
    return (
      this.state.pending_monitor || {
        total_pending: 0,
        over_20_minutes: 0,
        within_20_minutes: 0,
        updated_at: "-",
      }
    );
  };
  Share = async (item) => {
    this.setState({ ...item, chat_id: global.chat_room[0].list[0].value });
    if (!this.share) return;
    loading(true);
    const image = await captureShareImage(this.share);
    this.setState({ modal_share: true, share_image: image });
    loading(false);
  };
  SubmitShare = async () => {
    loading(true);
    const {share_image, chat_id, type, status, ref_no} = this.state;
    await sendShareToTelegram(chat_id, '' + getShareTitle(type, status) + '\nRef No: ' + ref_no, share_image);
    loading(false);
    alert("", "success");
    this.setState({modal_share: false});

  }
  DownloadShare = async () => {
    const {share_image} = this.state;
    downloadShareImage(share_image);
  }


  // ป้ายชื่อประเภทธุรกรรมจาก query type (deposits / withdrawals) ใช้ซ้ำทั้งหัวหน้าและ modal
  typeLabel = () => {
    const t = params("type") || "";
    return t.charAt(0).toUpperCase() + t.slice(1);
  };

  gatewayLogo = (gateway) => GATEWAY_LOGO[gateway];

  render() {
    const {
      select,
      modal_create,
      modal_update,
      modal_update_datetime,
      modal_detail,
      modal_mismatch,

      page,
      page_size,
      table_updated_at,
      table_auto_refresh,
      table_refresh_countdown,
      show_full,

      filter_status,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_uid,
      filter_search_mode,
      filter_currency,
      filter_broker,
      data,
      loaded,
      count,
      data_broker,
      data_customer,
      data_bank,
      data_bank_payout,
      data_bank_payout_lak,
      broker_id,
      customer_id,
      type,
      ref_no,
      status,
      amount,
      created_at,
      fee,
      fee_rate,
      fee_type,
      vat,
      is_vat,
      is_topup,
      amount_net,
      currency,
      remark,
      status_reason,
      broker,
      customer,
      cost_gateway,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,

      mismatch_bank_code,
      mismatch_bank_account_number,
      mismatch_bank_account_name_th,
      mismatch_bank_account_name_en,
      is_usdt,
      ref_no_refund,

      hover_index,
      hover_info_index,
      hover_monitor_card,
      inline_help_popup,
      pending_auto_refresh_enabled,
      pending_auto_refresh_countdown,

      modal_share,
      share_image,
      chat_id,
    } = this.state;
    const pendingMonitor = this.getPendingMonitorConfig();
    const focusedRowIndex = hover_info_index !== -1 ? hover_info_index : hover_index !== -1 ? hover_index : -1;
    const hasFocusedOverlay = Boolean(hover_monitor_card) || hover_index !== -1 || hover_info_index !== -1;
    const visibleColumns = columnDefs().filter((column) => this.isColumn(column.key));
    const rows = Array.isArray(data) ? data : [];
    const typeLabel = this.typeLabel();
    const isDeposits = params("type") === "deposits";
    const selectedBrokerLabel = data_broker?.find((b) => b.value === filter_broker)?.label;
    const bankIcon = (code) => global.bank?.find((b) => b.value === code)?.icon || "bank.png";
    const cur = currency || "THB";
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className={`market-monitor-overlay ${hasFocusedOverlay ? "show" : ""}`}></div>
          {inline_help_popup && (
            <div
              className="inline-help-popup"
              style={{
                left: inline_help_popup.left,
                top: inline_help_popup.top,
              }}
            >
              <div
                className="fw-semibold mb-1"
                style={{
                  fontSize: 12,
                  color: inline_help_popup.titleColor || "#344054",
                }}
              >
                {inline_help_popup.title}
              </div>
              {inline_help_popup.lines?.map((line, idx) => (
                <div key={`inline-help-${idx}`} className="text-14">
                  {line}
                </div>
              ))}
              {inline_help_popup.copyable && (
                <div
                  className="fw-semibold mt-1"
                  style={{
                    fontSize: 11,
                    color: inline_help_popup.copied ? "#079455" : "#98a2b3",
                  }}
                >
                  {inline_help_popup.copied ? "Copied!" : "Click to copy"}
                </div>
              )}
            </div>
          )}

          {/* HERO */}
          <div className="ar-hero pu-om-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Transactions</div>
                <div className="ar-title">{typeLabel} Management</div>
                <div className="ar-subtitle">Manage and monitor {typeLabel.toLowerCase()} transactions</div>
              </div>

              {/* PENDING MONITOR */}
              <div className="ar-hero-actions ms-auto">
                <div className="dw-hero-right">
                  <div className="dw-hero-buttons">
<button
                    className="ar-btn-ghost"
                    onClick={async () => {
                      this.ExportCSV();
                    }}
                  >
                    <span className="icon me-2">{""}</span>Export CSV
                  </button>
                  {isDeposits && profile.user_type === "super_user" && (
                    <button
                      className="ar-btn-ghost"
                      onClick={async () => {
                        this.inquiryAll();
                      }}
                    >
                      <span className="icon me-2">{""}</span>Inquiry All
                    </button>
                  )}
                  {isDeposits && (
                    <button
                      className={`ar-btn-ghost ${params("type")}.create`}
                      onClick={async () => {
                        this.setState({
                          id: "",
                          currency: "THB",
                          broker_id: profile?.user_type === "broker" ? profile?.broker?.uid : "",
                          customer_id: "",
                          ref_no: "",
                          amount: "",
                          is_topup: true,
                          is_hq: false,
                          modal_create: true,
                        });
                      }}
                    >
                      <span className="icon me-2">{""}</span>Create Topup
                    </button>
                  )}
                  <button
                    className={`ar-btn-gold ${params("type")}.create`}
                    onClick={async () => {
                      this.setState({
                        id: "",
                        currency: "THB",
                        broker_id: profile?.user_type === "broker" ? profile?.broker?.uid : "",
                        customer_id: "",
                        ref_no: "",
                        amount: "",
                        is_topup: false,
                        is_hq: false,
                        modal_create: true,
                      });
                    }}
                  >
                    <span className="icon me-2">{""}</span>Create {typeLabel}
                  </button>
                  </div>
                  <div className="dw-hero-monitor">
                <div className="pu-om-monitor">
                <div className="pu-om-monitor-meta">
                  <div className="pu-om-monitor-label">Pending Monitor</div>
                  <div className="pu-om-monitor-updated">Updated {pendingMonitor.updated_at}</div>
                </div>
                {isDeposits && (
                  <div
                    className={`pu-om-kpi market-monitor-card ${hover_monitor_card === "over_20" ? "is-active" : ""}`}
                    style={{ cursor: "help" }}
                    onMouseEnter={() => this.setState({ hover_monitor_card: "over_20" })}
                    onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                  >
                    <div className="pu-om-kpi-label">Over 20 min</div>
                    <div className="pu-om-kpi-value pu-dw-kpi-danger">{pendingMonitor.over_20_minutes}</div>
                    <div className="market-monitor-tooltip">
                      <div className="fw-semibold mb-1" style={{ fontSize: 13, color: "#d0312d" }}>
                        Over 20 min
                      </div>
                      <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                        Total <span className="fw-semibold">pending</span> transactions that have been expired for more than 20 minutes.
                      </div>
                    </div>
                  </div>
                )}
                {isDeposits && (
                  <div
                    className={`pu-om-kpi market-monitor-card ${hover_monitor_card === "within_20" ? "is-active" : ""}`}
                    style={{ cursor: "help" }}
                    onMouseEnter={() => this.setState({ hover_monitor_card: "within_20" })}
                    onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                  >
                    <div className="pu-om-kpi-label">Within 20 min</div>
                    <div className="pu-om-kpi-value">{pendingMonitor.within_20_minutes}</div>
                    <div className="market-monitor-tooltip">
                      <div className="fw-semibold mb-1" style={{ fontSize: 13, color: "#8a5300" }}>
                        Within 20 min
                      </div>
                      <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                        Total <span className="fw-semibold">pending</span> transactions that are still within the 20-minute window.
                      </div>
                    </div>
                  </div>
                )}
                {!isDeposits && (
                  <div
                    className={`pu-om-kpi market-monitor-card ${hover_monitor_card === "all_pending" ? "is-active" : ""}`}
                    style={{ cursor: "help" }}
                    onMouseEnter={() => this.setState({ hover_monitor_card: "all_pending" })}
                    onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                  >
                    <div className="pu-om-kpi-label">All pending</div>
                    <div className="pu-om-kpi-value">{pendingMonitor.total_pending}</div>
                    <div className="market-monitor-tooltip">
                      <div className="fw-semibold mb-1" style={{ fontSize: 13, color: "#d17b00" }}>
                        All pending
                      </div>
                      <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                        Total number of transactions currently in <span className="fw-semibold">pending</span> status.
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`market-monitor-card ${hover_monitor_card === "auto_update" ? "is-active" : ""}`}
                  onMouseEnter={() => this.setState({ hover_monitor_card: "auto_update" })}
                  onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                >
                  <button type="button" className={`pu-om-kpi pu-om-kpi-btn ${pending_auto_refresh_enabled ? "active" : ""}`} onClick={this.TogglePendingAutoRefresh}>
                    <div className="pu-om-kpi-label">
                      <span className="icon me-1">{""}</span>Auto Update
                    </div>
                    <div className="pu-om-kpi-value">{pending_auto_refresh_enabled ? `${pending_auto_refresh_countdown}s` : "Off"}</div>
                  </button>
                  <div className="market-monitor-tooltip">
                    <div className="fw-semibold mb-1" style={{ fontSize: 13, color: "#8a5300" }}>
                      Auto Update
                    </div>
                    <div style={{ fontSize: 12, lineHeight: 1.5 }}>Turn automatic refresh for the pending monitor on or off. The data updates based on the countdown timer.</div>
                  </div>
                </div>
              </div>
              </div>
                </div>
                  
              </div>
            </div>

            {/* FILTER */}
            <div className="ar-toolbar pu-om-filter mt-3">
              <div className="pu-om-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
                <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
              </div>
              <div className="pu-om-filter-grid">
                <div className={`pu-om-field pu-om-field-search pu-dw-field-search ${show_full ? "pu-dw-field-full" : ""}`}>
                  <span className="pu-om-field-label">{show_full ? "Transaction UIDs" : filter_search_mode === "uid" ? "Transaction UID" : "Search"}</span>
                  {show_full ? (
                    <div className="pu-dw-textarea-wrap">
                      <textarea
                        rows={5}
                        className="form-control pu-dw-textarea"
                        placeholder="Paste transaction UID here..."
                        onChange={(e) => {
                          this.setState({ filter_data_search: e.target.value });
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") this.Get(1);
                        }}
                        value={filter_data_search}
                      />
                      <button type="button" className="pu-dw-expand" title="Collapse" onClick={() => this.setState({ show_full: false })}>
                        <span className="icon">{""}</span>
                      </button>
                    </div>
                  ) : (
                    <div className="pu-om-search pu-dw-search">
                      <span className="icon pu-om-search-icon">{filter_search_mode === "uid" ? "" : ""}</span>
                      <input
                        type="text"
                        placeholder={filter_search_mode === "uid" ? "Paste transaction UID here..." : "Ref no. / customer..."}
                        onChange={(e) => {
                          this.setState(filter_search_mode === "uid" ? { filter_uid: e.target.value } : { filter_data_search: e.target.value });
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") this.Get(1);
                        }}
                        value={filter_search_mode === "uid" ? filter_uid : filter_data_search}
                      />
                      <button type="button" className="pu-om-mode pu-dw-expand-btn" title="Paste multiple UIDs" onClick={() => this.setState({ show_full: true, filter_search_mode: "general" })}>
                        <span className="icon">{""}</span>
                      </button>
                      <div className="pu-om-modes">
                        <div
                          className={`filter-search-mode-trigger market-monitor-card ${hover_monitor_card === "search_general" ? "is-active" : ""}`}
                          onMouseEnter={() => this.setState({ hover_monitor_card: "search_general" })}
                          onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                        >
                          <button type="button" className={`pu-om-mode ${filter_search_mode === "general" ? "active" : ""}`} onClick={() => this.setSearchMode("general")}>
                            <span className="icon">{""}</span>
                          </button>
                          <div className="market-monitor-tooltip">
                            <div className="fw-semibold mb-1" style={{ fontSize: 13, color: "#8a5300" }}>
                              General Search
                            </div>
                            <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                              Search by <span className="fw-semibold">Ref no.</span> or <span className="fw-semibold">customer</span>.
                            </div>
                          </div>
                        </div>
                        <div
                          className={`filter-search-mode-trigger market-monitor-card ${hover_monitor_card === "search_uid" ? "is-active" : ""}`}
                          onMouseEnter={() => this.setState({ hover_monitor_card: "search_uid" })}
                          onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                        >
                          <button type="button" className={`pu-om-mode ${filter_search_mode === "uid" ? "active" : ""}`} onClick={() => this.setSearchMode("uid")}>
                            <span className="icon">{""}</span>
                          </button>
                          <div className="market-monitor-tooltip">
                            <div className="fw-semibold mb-1" style={{ fontSize: 13, color: "#8a5300" }}>
                              UID Search
                            </div>
                            <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                              Search by exact <span className="fw-semibold">transaction UID</span> for a single record.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {["super_user", "admin"].includes(profile?.user_type) ? (
                  <div className="pu-om-field">
                    <span className="pu-om-field-label">Broker</span>
                    <Select
                      className="form-control"
                      placeholder="All brokers"
                      options={data_broker}
                      onChange={(e) => {
                        this.setState({
                          filter_broker: e,
                        });
                      }}
                      value={filter_broker}
                    />
                  </div>
                ) : (
                  <div className="pu-om-field d-none d-xxl-flex" />
                )}
                <div className="pu-om-field">
                  <span className="pu-om-field-label">Status</span>
                  <Select
                    className="form-control"
                    placeholder="All status"
                    options={[
                      { value: "", label: "-- All Status --" },
                      { value: "pending", label: "Pending" },
                      { value: "success", label: "Success" },
                      { value: "mismatch", label: "MisMatch" },
                      { value: "pending-refund", label: "Pending Refund" },
                      { value: "refund", label: "Refund" },
                      { value: "cancel", label: "Cancel" },
                    ]}
                    value={filter_status}
                    onChange={(v) => {
                      this.setState({ filter_status: v });
                    }}
                    default={false}
                  />
                </div>
                <div className="pu-om-field pu-om-field-date">
                  <span className="pu-om-field-label">Date Range</span>
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({
                        filter_start_date: e.start_date,
                        filter_end_date: e.end_date,
                      });
                    }}
                    value={{
                      start_date: filter_start_date,
                      end_date: filter_end_date,
                    }}
                    max={filter_end_date}
                  />
                </div>
                <div className="pu-om-filter-actions ar-toolbar-actions">
                  <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                    <span className="icon me-2">{""}</span>Search
                  </button>
                  <button
                    className="ar-btn-ghost"
                    onClick={() =>
                      this.setState(
                        {
                          filter_status: params("status") || "",
                          filter_start_date: params("ref_no") || params("uid") ? "" : format_date(new Date(new Date().setDate(new Date().getDate() - 3)), "yyyy-mm-dd", "en"),
                          filter_end_date: params("ref_no") || params("uid") ? "" : format_date(new Date(), "yyyy-mm-dd", "en"),
                          filter_data_search: params("ref_no") || "",
                          filter_uid: params("uid") || "",
                          filter_search_mode: params("uid") ? "uid" : "general",
                          filter_process_type: "",
                          filter_currency: "THB",
                          filter_broker: "",
                        },
                        () => this.Get(1)
                      )
                    }
                  >
                    <span className="icon me-2">{""}</span>Reset
                  </button>
                </div>
              </div>

              {/* CURRENCY */}
              <div className="ar-filter-foot">
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  {global.currency?.map((item) => (
                    <button
                      key={item.currency_code}
                      className={`ar-pill ${item.currency_code === filter_currency ? "active" : ""}`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      {item.currency_code}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head flex-wrap gap-2">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{isDeposits ? "" : ""}</span>
                  {typeLabel}
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">
                  {count > 0 ? `Showing ${(page - 1) * page_size + 1}–${Math.min(page * page_size, count)} of ${count}` : "No results"}
                  {selectedBrokerLabel ? <span className="ms-2">&middot; {selectedBrokerLabel}</span> : null}
                  {table_updated_at ? <span className="ms-2">&middot; Updated {table_updated_at}</span> : null}
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <button
                  type="button"
                  className="pu-om-ctl pu-ctl-plain"
                  onClick={() => {
                    this.Get(page, { silent: true });
                  }}
                >
                  <span className="icon me-1">{""}</span>Refresh
                </button>
                <button
                  type="button"
                  className={`pu-om-ctl pu-ctl-plain ${table_auto_refresh ? "active" : ""}`}
                  onClick={() => {
                    this.ToggleTableAutoRefresh();
                  }}
                >
                  <span className="icon me-1">{""}</span>
                  {table_auto_refresh ? `Auto ${table_refresh_countdown}s` : "Auto"}
                </button>
                <Select
                  className="form-control pu-om-rows pu-rows-plain"
                  placeholder="Rows"
                  options={PAGE_SIZE_OPTIONS.map((size) => ({
                    value: size,
                    label: `${size} rows`,
                  }))}
                  value={page_size}
                  onChange={(v) => {
                    this.setPageSize(Number(v));
                  }}
                />
                <Dropdown autoClose="outside" align="end">
                  <Dropdown.Toggle className="pu-om-ctl pu-ctl-plain" id="dw-columns">
                    <span className="icon me-1">{""}</span>Columns
                    <span className="pu-om-ctl-count">
                      {visibleColumns.length}/{columnDefs().length}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="pu-action-menu" style={{ minWidth: 190, maxHeight: 340, overflowY: "auto" }}>
                    <label className="pu-om-col fw-bold">
                      <input
                        type="checkbox"
                        className="form-check-input m-0 me-2"
                        checked={columnDefs().every((column) => this.isColumn(column.key))}
                        onChange={(e) => {
                          this.toggleAllColumns(e.target.checked);
                        }}
                      />
                      All columns
                    </label>
                    <div className="pu-action-sep" />
                    {columnDefs().map((column) => (
                      <label key={`column-${column.key}`} className="pu-om-col">
                        <input
                          type="checkbox"
                          className="form-check-input m-0 me-2"
                          checked={this.isColumn(column.key)}
                          onChange={() => {
                            this.toggleColumn(column.key);
                          }}
                        />
                        {column.label}
                      </label>
                    ))}
                    <div className="pu-action-sep" />
                    <button
                      type="button"
                      className="pu-om-col pu-om-col-reset"
                      onClick={() => {
                        this.resetColumns();
                      }}
                    >
                      Reset to default
                    </button>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="table-responsive hide-scrollbar" style={{ minHeight: 450, msOverflowStyle: "none", scrollbarWidth: "none" }}>
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    {this.isColumn("time") && <td className="text-nowrap">Time</td>}
                    {this.isColumn("ref_no") && <td className="text-nowrap">Ref No</td>}
                    {this.isColumn("ref_qr") && <td className="text-nowrap">{isDeposits ? "Ref QR" : "Ref Payout"}</td>}
                    {this.isColumn("gateway") && <td className="text-nowrap">Gateway</td>}
                    {this.isColumn("customer") && <td className="text-nowrap">Customer</td>}
                    {this.isColumn("bank") && <td className="text-nowrap">Bank</td>}
                    {this.isColumn("amount") && <td className="text-nowrap text-end">Amount</td>}
                    {this.isColumn("fee_rate") && <td className="text-nowrap text-end d-none d-md-table-cell">Fee %</td>}
                    {this.isColumn("fee") && <td className="text-nowrap text-end d-none d-md-table-cell">Fee</td>}
                    {this.isColumn("vat") && <td className="text-nowrap text-end d-none d-md-table-cell">VAT</td>}
                    {this.isColumn("amount_net") && <td className="text-nowrap text-end d-none d-md-table-cell">Amount Net</td>}
                    {this.isColumn("process") && <td className="text-nowrap text-center d-none d-md-table-cell">Process</td>}
                    {this.isColumn("status") && <td className="text-nowrap text-center wpx-100">Status</td>}
                    {this.isColumn("callback") && <td className="text-nowrap text-center wpx-100">Callback</td>}
                    {this.isColumn("actions") && <td className={`${params("type")}.update text-nowrap text-center td-actions`}>Actions</td>}
                  </tr>
                </thead>
                <tbody>
                  {loaded && rows.length === 0 ? (
                    <tr>
                      <td colSpan={visibleColumns.length || 1} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{isDeposits ? "" : ""}</span>
                          <div className="fw-bold">No {typeLabel.toLowerCase()} found</div>
                          <div className="text-secondary text-14">Try another search, status, date range or currency.</div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    rows.map((item, index) => {
                      const custName = item.customer?.name_en || "-";
                      const brokerName = item.broker?.name_en || item.broker?.name_th || "-";
                      const bank = item.bank_code ? global.bank.find((e) => e.value === item.bank_code) : null;
                      const idLines = [`originID: ${item.customer?.gateway_register?.[0]?.customer_id ?? "-"}`, `payoutID: ${item.customer?.gateway_register?.[0]?.uid ?? "-"}`];
                      const reason = StatusReason(item.status, item.status_reason);
                      const showReason = ["cancel", "success"].includes(item.status) && !(item.ref_no_refund && item.status === "success");
                      return (
                        <tr
                          key={item.uid || `array-${index}`}
                          className={`${index === select ? "pu-row-selected" : ""} ${focusedRowIndex === index ? "table-focus-row" : ""}`}
                          onDoubleClick={() => {
                            this.setState({
                              select: select === index ? -1 : index,
                            });
                          }}
                        >
                          {this.isColumn("time") && (
                            <td data-label="Time" className="text-nowrap">
                              <div className="pu-shq-time">{format_date(item.created_at, "dd/mm/yy", "en")}</div>
                              <div className="pu-sub pu-mono">{format_date(item.created_at, "hh:mm:ss", "en")}</div>
                            </td>
                          )}
                          {this.isColumn("ref_no") && (
                            <td data-label="Ref No" className="text-nowrap">
                              <div className="pu-uid">
                                <CopyCell value={item.ref_no} className="pu-shq-ref" duration={2000} />
                                {item.ref_no_refund && (
                                  <div className="pu-sub">
                                    refund: <span className="pu-mono ms-1">{item.ref_no_refund}</span>
                                    <span
                                      className="icon ms-1 pu-link pointer"
                                      title="Open refund transaction"
                                      onClick={() => {
                                        window.location.href = `/${linkRole(profile?.user_type)}/deposits-withdrawals?type=${isDeposits ? "withdrawals" : "deposits"}&ref_no=${item.ref_no_refund}`;
                                      }}
                                    >
                                      {""}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </td>
                          )}
                          {this.isColumn("ref_qr") && (
                            <td data-label={isDeposits ? "Ref QR" : "Ref Payout"} className="text-nowrap">
                              {item.qrs?.reference_id || item.reference_id ? <CopyCell value={item.qrs?.reference_id || item.reference_id} className="pu-shq-ref" duration={2000} /> : <span className="pu-none">-</span>}
                            </td>
                          )}
                          {this.isColumn("gateway") && (
                            <td data-label="Gateway" className="text-nowrap">
                              {item.gateway ? (
                                <div className="pu-gateway">
                                  <img
                                    src={this.gatewayLogo(item.gateway)}
                                    alt={item.gateway}
                                    width={24}
                                    height={24}
                                    className="rounded-circle pu-gateway-img"
                                    style={{
                                      objectFit: "cover",
                                      background: gateway_logo_background(item.gateway),
                                    }}
                                  />
                                  <div className="pu-gateway-name">{item.gateway}</div>
                                </div>
                              ) : (
                                <span className="pu-none">-</span>
                              )}
                            </td>
                          )}
                          {this.isColumn("customer") && (
                            <td data-label="Customer" className="text-nowrap">
                              <div className="pu-user">
                                <div className="min-w-0">
                                  <div className="pu-name text-truncate d-flex align-items-center" title={custName}>
                                    <span className="text-truncate">{custName}</span>
                                    <span
                                      className={`icon ms-2 pointer pu-info-plain ${hover_info_index === index ? "active" : ""}`}
                                      title="Customer IDs"
                                      onMouseEnter={(event) => {
                                        this.setState({ hover_info_index: index });
                                        this.showInlineHelpPopup(event, {
                                          title: "Customer IDs",
                                          titleColor: "#344054",
                                          lines: idLines,
                                          copyable: true,
                                        });
                                      }}
                                      onMouseLeave={() => {
                                        this.setState({ hover_info_index: -1 });
                                        this.hideInlineHelpPopup();
                                      }}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        this.copyInlineHelpText(idLines.join("\n"));
                                      }}
                                    >
                                      {""}
                                    </span>
                                  </div>
                                  <div className="pu-sub">
                                    <span className="icon me-1">{""}</span>
                                    <span className="text-truncate">{brokerName}</span>
                                  </div>
                                </div>
                              </div>
                            </td>
                          )}
                          {this.isColumn("bank") && (
                            <td data-label="Bank" className="text-nowrap">
                              {bank ? (
                                <div className="pu-bank">
                                  <img alt="bank" src={require(`../../assets/images/bank/${bank.icon || "bank.png"}`)} width={28} height={28} />
                                  <div className="min-w-0">
                                    <div className="pu-bank-code">{item.bank_code}</div>
                                    <div className="pu-sub pu-mono">{maskAccount(item.bank_account_number) || "-"}</div>
                                  </div>
                                </div>
                              ) : (
                                <span className="pu-none">-</span>
                              )}
                            </td>
                          )}
                          {this.isColumn("amount") && (
                            <td data-label="Amount" className="text-nowrap text-end">
                              <div className="pu-amount">{toFixed(item.amount, 2)}</div>
                            </td>
                          )}
                          {this.isColumn("fee_rate") && (
                            <td data-label="Fee %" className="text-nowrap text-end pu-num d-none d-md-table-cell">
                              {toFixed(item.fee_rate, 2)}%
                            </td>
                          )}
                          {this.isColumn("fee") && (
                            <td data-label="Fee" className="text-nowrap text-end pu-num d-none d-md-table-cell">
                              {toFixed(item.fee, 2)}
                            </td>
                          )}
                          {this.isColumn("vat") && (
                            <td data-label="VAT" className="text-nowrap text-end pu-num d-none d-md-table-cell">
                              {item.is_vat ? toFixed(item.vat, 2) : "0.00"}
                            </td>
                          )}
                          {this.isColumn("amount_net") && (
                            <td data-label="Amount Net" className="text-nowrap text-end d-none d-md-table-cell">
                              <div className="pu-amount pu-amount-gold">{toFixed(item.amount_net, 2)}</div>
                            </td>
                          )}
                          {this.isColumn("process") && (
                            <td data-label="Process" className="text-nowrap text-center d-none d-md-table-cell">
                              <div className="d-flex align-items-center justify-content-center">
                                {!item.is_topup && !item.is_hq && (item.process_type === "manual" ? Status("manual", "orange") : item.process_type === "auto" ? Status("auto", "primary") : Status("-", "secondary"))}
                                {item.is_topup && Status("topup", "info")}
                                {item.is_hq && Status("HQ", "purple")}
                              </div>
                            </td>
                          )}
                          {this.isColumn("status") && (
                            <td data-label="Status" className="text-nowrap text-center">
                              <div className="d-flex align-items-center justify-content-center">
                                {item.ref_no_refund && item.status === "success"
                                  ? Status("refund", "info")
                                  : isExpiredCancel(item.status, item.status_reason)
                                    ? // expired is a timeout, not a rejection: keep it
                                      // neutral so red stays reserved for real failures
                                      Status("cancel", "secondary")
                                    : StatusTnx(item.status)}
                                {showReason ? (
                                  <div
                                    className={`ms-1 inline-help-trigger ${hover_index === index ? "is-active" : ""}`}
                                    style={{
                                      background: "transparent",
                                      width: 16,
                                      height: 16,
                                      color: reason.color,
                                    }}
                                    onMouseEnter={(event) => {
                                      this.setState({ hover_index: index });
                                      this.showInlineHelpPopup(event, {
                                        title: reason.title,
                                        titleColor: reason.color,
                                        lines: [item.status_reason || "-"],
                                        copyable: true,
                                      });
                                    }}
                                    onMouseLeave={() => {
                                      this.setState({ hover_index: -1 });
                                      this.hideInlineHelpPopup();
                                    }}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      this.copyInlineHelpText(item.status_reason);
                                    }}
                                  >
                                    {StatusIcon(reason.icon)}
                                  </div>
                                ) : null}
                              </div>
                            </td>
                          )}
                          {this.isColumn("callback") && (
                            <td data-label="Callback" className="text-nowrap text-center">
                              <div className="d-flex align-items-center justify-content-center gap-1">
                                {item.is_callback ? Status("sent", "success") : Status("waiting", "warning")}
                                {item.count_callback ? (
                                  <span className={`pu-dw-cb-count ${item.is_callback && item.count_callback === 1 ? "ok" : "warn"}`} title={`Callback sent ${item.count_callback} time(s)`}>
                                    ×{item.count_callback}
                                  </span>
                                ) : null}
                              </div>
                            </td>
                          )}
                          {this.isColumn("actions") && (
                            <td data-label="Actions" className={`${params("type")}.update text-center td-actions`}>
                              <Dropdown align="end">
                                <Dropdown.Toggle className="pu-action-toggle" id={`dw-actions-${index}`}>
                                  Action
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                  <Dropdown.Item
                                    className="pu-action-item"
                                    onClick={() => {
                                      this.setState({ ...item, modal_detail: true });
                                    }}
                                  >
                                    <span className="icon">{""}</span>Detail
                                  </Dropdown.Item>
                                  {item.status === "pending" && !item.is_topup && (
                                    <Dropdown.Item
                                      className={`${params("type")}.update pu-action-item`}
                                      onClick={() => {
                                        this.setState({
                                          ...item,
                                          broker_id: item?.broker?.uid || "",
                                          modal_update: true,
                                        });
                                      }}
                                    >
                                      <span className="icon">{""}</span>Update
                                    </Dropdown.Item>
                                  )}
                                  {["success", "refund", "cancel"].includes(item.status) && (
                                    <Dropdown.Item
                                      className={`${params("type")}.update pu-action-item`}
                                      onClick={() => {
                                        this.setState({
                                          ...item,
                                          broker_id: item?.broker?.uid || "",
                                          created_at: format_date(item?.created_at, "yyyy-mm-dd hh:mm", "en"),
                                          modal_update_datetime: true,
                                        });
                                      }}
                                    >
                                      <span className="icon">{""}</span>Update DateTime
                                    </Dropdown.Item>
                                  )}
                                  <Dropdown.Item
                                    className="pu-action-item"
                                    onClick={() => {
                                      this.Share(item);
                                    }}
                                  >
                                    <span className="icon">{""}</span>Share
                                  </Dropdown.Item>
                                  <div className="pu-action-sep" />
                                  {["pending", "mismatch", "pending-refund", "cancel"].includes(item.status) && (
                                    <Dropdown.Item
                                      className={`${params("type")}.update pu-action-item`}
                                      onClick={() => {
                                        this.setState(
                                          {
                                            ...item,
                                            status: item.status === "pending-refund" ? "refund" : "success",
                                          },
                                          () => {
                                            this.Update();
                                          }
                                        );
                                      }}
                                    >
                                      <span className="icon">{""}</span>Approve
                                    </Dropdown.Item>
                                  )}
                                  {(["pending", "mismatch", "pending-refund"].includes(item.status) || (profile.user_type === "super_user" && item.status === "success")) && (
                                    <Dropdown.Item
                                      className={`${params("type")}.update pu-action-item danger`}
                                      onClick={() => {
                                        this.setState({ ...item, status: "cancel" }, () => {
                                          this.Update();
                                        });
                                      }}
                                    >
                                      <span className="icon">{""}</span>Reject
                                    </Dropdown.Item>
                                  )}
                                  {["success"].includes(item.status) && profile.user_type === "super_user" && isDeposits && (
                                    <Dropdown.Item
                                      className={`${params("type")}.update pu-action-item`}
                                      onClick={() => {
                                        this.setState({
                                          ...item,
                                          broker_id: item?.broker?.uid || "",
                                          modal_mismatch: true,
                                        });
                                      }}
                                    >
                                      <span className="icon">{""}</span>Mismatch
                                    </Dropdown.Item>
                                  )}
                                  {["pending", "cancel", "success"].includes(item.status) && (
                                    <Dropdown.Item
                                      className={`${params("type")}.update pu-action-item`}
                                      onClick={() => {
                                        this.setState(
                                          {
                                            ...item,
                                            broker_id: item?.broker?.uid || "",
                                          },
                                          () => {
                                            this.Inquiry();
                                          }
                                        );
                                      }}
                                    >
                                      <span className="icon">{""}</span>Inquiry
                                    </Dropdown.Item>
                                  )}
                                  {["success", "mismatch", "cancel", "refund"].includes(item.status) && (
                                    <Dropdown.Item
                                      className={`${params("type")}.update pu-action-item`}
                                      onClick={() => {
                                        this.setState(
                                          {
                                            ...item,
                                            broker_id: item?.broker?.uid || "",
                                          },
                                          () => {
                                            this.Callback();
                                          }
                                        );
                                      }}
                                    >
                                      <span className="icon">{""}</span>Resend Callback
                                    </Dropdown.Item>
                                  )}
                                  {["success", "refund"].includes(item.status) && profile.user_type === "super_user" && (
                                    <>
                                      <div className="pu-action-sep" />
                                      <Dropdown.Item
                                        className={`${params("type")}.delete pu-action-item danger`}
                                        onClick={() => {
                                          this.Delete(item.uid);
                                        }}
                                      >
                                        <span className="icon">{""}</span>Remove
                                      </Dropdown.Item>
                                    </>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          )}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination className="mb-3" count={Math.ceil(count / page_size) || 1} page={page} showFirstButton showLastButton onChange={(_, value) => this.Get(value)} />
          </div>
          {/* SHARE */}
          <div style={{ opacity: 0, position: "absolute", left: -9999 }}>
            <div className="wpx-450 p-3" id="share" ref={(el) => (this.share = el)} style={{
        backgroundImage: `url(${WATERMARK})`,
        backgroundRepeat: "repeat"
    }}>
                <div className="d-flex justify-content-between">
                    <div>
                <h4 className="fw-bold d-flex align-items-center mb-0">
                {getShareTitle(
                    is_topup ? "topup" : type,
                    ref_no_refund && status === "success" ? "refund" : status,
                    )}

                <div className="ms-2">{StatusTnxShare(status)}</div>
                </h4>
                <div className="w-100">
                {format_date(created_at, "dd/mm/yyyy hh:mm:ss", "en")}
                </div>
                <div className="w-100">Ref No: {ref_no}</div>
                    </div>
                    <img alt="logo" src={LOGO512} height={50} style={{ objectFit: "contain" }} />
                </div>

                <hr />
                <div className="d-flex mb-1">
                <div className="wpx-100 mt-2 fw-bold">Broker</div>
                <div className="w-100 mt-2">{broker?.name_en || "-"}</div>
                </div>
                <div className="d-flex mb-1">
                <div className="wpx-100 mt-2 fw-bold">Customer</div>
                <div className="w-100 mt-2">{customer?.name_en || "-"}</div>
                </div>
                

                <div className="d-flex mb-1">
                <div className="wpx-100 mt-2 fw-bold">Amount</div>
                <div className="w-100 mt-2">
                    {toFixed(amount, 2)} {currency || "THB"}
                </div>
                </div>
                <div className="d-flex mb-1">
                <div className="wpx-100 mt-2 fw-bold">Fee</div>
                <div className="w-100 mt-2">
                    {toFixed(fee, 2)} {currency || "THB"}
                </div>
                </div>
                <div className="d-flex mb-1">
                <div className="wpx-100 mt-2 fw-bold">Vat</div>
                <div className="w-100 mt-2">
                    {toFixed(vat, 2)} {currency || "THB"}
                </div>
                </div>
                <div className="d-flex mb-1">
                <div className="wpx-100 mt-2 fw-bold">Amount Net</div>
                <div className="w-100 mt-2">
                    {toFixed(amount_net, 2)} {currency || "THB"}
                </div>
                </div>
                <div className="d-flex mb-1">
                <div className="wpx-100 mt-2 fw-bold">Remark</div>
                <div className="w-100 mt-2">{remark || status_reason || "-"}</div>
                </div>

                {bank_code && (
                <>
                    <hr />
                    <div className="d-flex align-items-center">
                    <div className="wpx-100">
                        <img
                        alt="bank"
                        src={require(
                            `../../assets/images/bank/${global.bank.find((b) => b.value === bank_code)?.icon || "bank.png"}`,
                        )}
                        width={55}
                        height={55}
                        />
                    </div>
                    <div>
                        <div className="w-100">
                        {bank_account_name_en || bank_account_name_th}
                        </div>
                        <div className="w-100">{bank_code}</div>
                        <div className="w-100">{maskAccount(bank_account_number)}</div>
                    </div>
                    </div>
                </>
                )}
            </div>
          </div>
        </div>

        {/* CREATE */}
        <Modal show={modal_create} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_create: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">New transaction</div>
              <h5 className="fw-bold mb-0">Create {is_topup ? "Topup" : typeLabel}</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{isDeposits ? "" : ""}</span>Transaction
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Currency{required}</label>
                  <Select
                    className="form-control"
                    placeholder="Select currency"
                    options={global.currency?.map((e) => ({
                      label: e.currency_code,
                      value: e.currency_code,
                      front: e.image,
                    }))}
                    onChange={(e, i) => {
                      this.setState(
                        {
                          currency: e,
                          broker_id: e ? broker_id : "",
                          customer_id: e ? customer_id : "",
                          bank_code: e ? bank_code : "",
                          bank_account_number: e ? bank_account_number : "",
                          bank_account_name_th: e ? bank_account_name_th : "",
                          bank_account_name_en: e ? bank_account_name_en : "",
                        },
                        () => {
                          this.GetCustomer();
                        }
                      );
                    }}
                    value={currency}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Broker{required}</label>
                  <Select
                    className="form-control"
                    placeholder="Select broker"
                    options={data_broker}
                    onChange={(e) => {
                      this.setState(
                        {
                          broker_id: e,
                          customer_id: "",
                          bank_code: "",
                          bank_account_number: "",
                          bank_account_name_th: "",
                          bank_account_name_en: "",
                        },
                        () => {
                          this.GetCustomer();
                        }
                      );
                    }}
                    value={broker_id}
                    disabled={!currency}
                  />
                </div>
                <div className="col-12">
                  <label className="pr-label">Customer{required}</label>
                  <Select
                    className="form-control"
                    placeholder="Select customer"
                    options={data_customer?.filter((e) => e.broker === broker_id).filter((e) => e.currency === currency)}
                    onChange={(e, i) => {
                      this.setState({
                        customer_id: e,
                        bank_code: e ? i.bank_code : "",
                        bank_account_name_th: e ? i.bank_account_name_th : "",
                        bank_account_name_en: e ? i.bank_account_name_en : "",
                        bank_account_number: e ? i.bank_account_number : "",
                      });
                    }}
                    onKeyUp={(e) => {
                      this.GetCustomer(e);
                    }}
                    value={customer_id}
                    disabled={!broker_id}
                  />
                </div>
                <div className="col-12">
                  <label className="pr-label">Ref no{required}</label>
                  <div className="pu-password">
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Reference number"
                      maxLength={100}
                      onChange={(e) => {
                        this.setState({ ref_no: e.target.value });
                      }}
                      value={ref_no}
                    />
                    <button
                      type="button"
                      className="pu-generate"
                      title="Generate a reference number"
                      onClick={() => {
                        this.setState({ ref_no: new Date().getTime().toString() });
                      }}
                    >
                      <span className="icon me-2">{""}</span>Generate
                    </button>
                  </div>
                </div>
                <div className="col-12">
                  <label className="pr-label">Amount{required}</label>
                  <div className="position-relative">
                    <NumericFormat
                      thousandSeparator=","
                      decimalScale={2}
                      type="text"
                      className="form-control pr-input pe-5"
                      placeholder="0.00"
                      value={amount}
                      onValueChange={(e) => {
                        this.setState({ amount: e.value });
                      }}
                    />
                    <span className="pu-input-suffix">{cur}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={`pu-section ${!broker_id ? "pu-section-muted" : ""}`}>
              <div className="pu-section-title">
                <span className="icon">{""}</span>Bank Information
                {!broker_id && <span className="pu-section-note">Select a broker first</span>}
              </div>
              {broker_id ? (
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Bank Name{required}</label>
                    <Select
                      className="form-control"
                      placeholder="Select bank"
                      options={data_bank}
                      onChange={(e) => {
                        this.setState({ bank_code: e });
                      }}
                      value={bank_code}
                      disabled={customer_id}
                    ></Select>
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Account Number{required}</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Account number"
                      maxLength={20}
                      onChange={(e) => {
                        if (!float(e.target.value)) return;
                        this.setState({ bank_account_number: e.target.value });
                      }}
                      value={bank_account_number}
                      disabled={customer_id}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Account Name TH{required}</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="ชื่อบัญชีภาษาไทย"
                      onChange={(e) => {
                        this.setState({ bank_account_name_th: e.target.value });
                      }}
                      value={bank_account_name_th}
                      disabled={customer_id}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Account Name EN{required}</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Account name in English"
                      onChange={(e) => {
                        this.setState({ bank_account_name_en: e.target.value });
                      }}
                      value={bank_account_name_en}
                      disabled={customer_id}
                    />
                  </div>
                  {customer_id && <div className="col-12 pu-hint mt-0">Bank details are taken from the selected customer.</div>}
                </div>
              ) : (
                <div className="pu-hint">Bank details are filled in automatically once a broker is selected.</div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.Create();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_create: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* UPDATE */}
        <Modal show={modal_update} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_update: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Edit transaction</div>
              <h5 className="fw-bold mb-0">Update {typeLabel}</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{isDeposits ? "" : ""}</span>Transaction
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Status</span>
                <span className="pu-kv-value">{StatusTnx(status)}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Ref No.</span>
                <span className="pu-kv-value pu-mono">{ref_no}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Time</span>
                <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy", "en")}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Type</span>
                <span className="pu-kv-value text-capitalize">{type}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Customer</span>
                <span className="pu-kv-value">{customer?.name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Customer Email</span>
                <span className="pu-kv-value">{customer?.email || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Broker</span>
                <span className="pu-kv-value">{broker?.name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Remark</span>
                <span className="pu-kv-value">{remark || <span className="pu-none">-</span>}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Accountant Remark</span>
                <span className="pu-kv-value">
                  <span className="pu-none">-</span>
                </span>
              </div>
            </div>

            <div className={`pu-section ${is_usdt ? "pu-section-muted" : ""}`}>
              <div className="pu-section-title">
                <span className="icon">{""}</span>Fee &amp; VAT
                {is_usdt && <span className="pu-section-note">Not applied for USDT</span>}
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Fee Rate Type</label>
                  <Select
                    className="form-control"
                    placeholder="Fee rate type"
                    options={[
                      { value: "percentage", label: "Percentage" },
                      { value: "fixed", label: "Fixed" },
                    ]}
                    onChange={(e) => {
                      this.setState({ fee_type: e });
                      setTimeout(() => {
                        this.calDetail();
                      }, 10);
                    }}
                    value={fee_type}
                    disabled={is_usdt}
                  ></Select>
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Fee Rate</label>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control pr-input pe-5"
                      placeholder="0.00"
                      onChange={(e) => {
                        if (!float(e.target.value, 4)) return;
                        this.setState({ fee_rate: e.target.value });
                        setTimeout(() => {
                          this.calDetail();
                        }, 10);
                      }}
                      value={!is_usdt ? fee_rate : "0.00"}
                      disabled={is_usdt}
                    />
                    <span className="pu-input-suffix">{fee_type === "percentage" ? "%" : cur}</span>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="pu-toggle">
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_vat: e });
                        setTimeout(() => {
                          this.calDetail();
                        }, 10);
                      }}
                      checked={is_vat && !is_usdt}
                      disabled={is_usdt}
                    />
                    <div>
                      <div className="pu-toggle-title">{is_vat && !is_usdt ? "VAT" : "NO VAT"}</div>
                      <div className="pu-toggle-desc">Apply VAT on top of the fee</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="pu-toggle">
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_usdt: e });
                        setTimeout(() => {
                          this.calDetail();
                        }, 10);
                      }}
                      checked={is_usdt}
                    />
                    <div>
                      <div className="pu-toggle-title">USDT</div>
                      <div className="pu-toggle-desc">Settle in USDT, fee and VAT are not applied</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pu-section pu-section-gold">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Summary
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Amount</span>
                <span className="pu-kv-value">
                  {toFixed(amount, 2)} {cur}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Fee</span>
                <span className="pu-kv-value">
                  {!is_usdt ? toFixed(fee, 2) : "0.00"} {cur}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">VAT</span>
                <span className="pu-kv-value">
                  {!is_usdt ? toFixed(vat, 2) : "0.00"} {cur}
                </span>
              </div>
              <div className="pu-kv total">
                <span className="pu-kv-label">Amount Net</span>
                <span className="pu-kv-value">
                  {!is_usdt ? toFixed(amount_net, 2) : toFixed(amount, 2)} {cur}
                </span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.Update();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_update: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* UPDATE DATETIME */}
        <Modal show={modal_update_datetime} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_update_datetime: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Edit transaction time</div>
              <h5 className="fw-bold mb-0">
                Update DateTime <span className="pu-mono text-secondary fw-normal text-14">{ref_no}</span>
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Date Time
              </div>
              <label className="pr-label">Transaction date and time</label>
              <input
                type="datetime-local"
                className="form-control pr-input"
                placeholder="Date Time..."
                onChange={(e) => {
                  this.setState({ created_at: e.target.value });
                }}
                value={created_at}
              />
              <div className="pu-hint">Changing the time moves this transaction to another settlement day.</div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.UpdateDateTime();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_update_datetime: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* UPDATE MISMATCH */}
        <Modal show={modal_mismatch} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_mismatch: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Mark as mismatch</div>
              <h5 className="fw-bold mb-0">
                Update Mismatch <span className="pu-mono text-secondary fw-normal text-14">{ref_no}</span>
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section pu-mm-registered">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Registered Account
                <span className="pu-section-note">Customer on file</span>
              </div>
              <div className="pu-bank mb-3">
                <img alt="bank" src={require(`../../assets/images/bank/${bankIcon(bank_code)}`)} />
                <div className="min-w-0">
                  <div className="pu-bank-code">{bank_code || "-"}</div>
                  <div className="pu-sub pu-mono">{maskAccount(bank_account_number) || "-"}</div>
                </div>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Account Name EN</span>
                <span className="pu-kv-value">{bank_account_name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Account Name TH</span>
                <span className="pu-kv-value">{bank_account_name_th || "-"}</span>
              </div>
            </div>

            <div className="pu-section pu-mm-paying">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Paying Account
                <span className="pu-section-note">Detected from transfer</span>
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Bank Name</label>
                  <Select
                    className="form-control"
                    placeholder="Select bank"
                    options={currency === "THB" ? data_bank_payout : data_bank_payout_lak}
                    onChange={(e) => {
                      this.setState({ mismatch_bank_code: e });
                    }}
                    value={mismatch_bank_code}
                  ></Select>
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Bank Account No.</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account number"
                    onChange={(e) => {
                      this.setState({ mismatch_bank_account_number: e.target.value });
                    }}
                    value={mismatch_bank_account_number}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Account Name TH</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="ชื่อบัญชีภาษาไทย"
                    onChange={(e) => {
                      this.setState({ mismatch_bank_account_name_th: e.target.value });
                    }}
                    value={mismatch_bank_account_name_th}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Account Name EN</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account name in English"
                    onChange={(e) => {
                      this.setState({ mismatch_bank_account_name_en: e.target.value });
                    }}
                    value={mismatch_bank_account_name_en}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.UpdateMismatch();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_mismatch: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* DETAIL */}
        <Modal show={modal_detail} size="lg" dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_detail: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">{typeLabel} detail</div>
              <h5 className="fw-bold mb-0">
                Transaction <span className="pu-mono text-secondary fw-normal text-14">{ref_no}</span>
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <div className="pu-section h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{isDeposits ? "" : ""}</span>Transaction
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Status</span>
                    <span className="pu-kv-value">{StatusTnx(status)}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Ref No.</span>
                    <span className="pu-kv-value pu-mono">{ref_no}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Time</span>
                    <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy hh:mm:ss", "en")}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Type</span>
                    <span className="pu-kv-value text-capitalize">{type}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Customer</span>
                    <span className="pu-kv-value">{customer?.name_en || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Customer Email</span>
                    <span className="pu-kv-value text-truncate">{customer?.email || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Broker</span>
                    <span className="pu-kv-value">{broker?.name_en || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Remark</span>
                    <span className="pu-kv-value">{remark || <span className="pu-none">-</span>}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Status Remark</span>
                    <span className="pu-kv-value">{status_reason || <span className="pu-none">-</span>}</span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="pu-section pu-section-gold h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Fee &amp; Amount
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee Rate Type</span>
                    <span className="pu-kv-value text-capitalize">{fee_type || "-"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee Rate</span>
                    <span className="pu-kv-value">
                      {toFixed(fee_rate, 2)} {fee_type === "percentage" ? "%" : cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Amount</span>
                    <span className="pu-kv-value">
                      {toFixed(amount, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee Gateway</span>
                    <span className="pu-kv-value">
                      {toFixed(cost_gateway, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">Fee</span>
                    <span className="pu-kv-value">
                      {toFixed(fee, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">VAT Type</span>
                    <span className="pu-kv-value">{is_vat ? "VAT" : "NO VAT"}</span>
                  </div>
                  <div className="pu-kv">
                    <span className="pu-kv-label">VAT</span>
                    <span className="pu-kv-value">
                      {toFixed(vat, 2)} {cur}
                    </span>
                  </div>
                  <div className="pu-kv total">
                    <span className="pu-kv-label">Amount Net</span>
                    <span className="pu-kv-value">
                      {toFixed(amount_net, 2)} {cur}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="pu-section mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Bank Information
                  </div>
                  <div className="row g-3 align-items-center">
                    <div className="col-12 col-md-5">
                      <div className="pu-bank">
                        <img alt="bank" src={require(`../../assets/images/bank/${bankIcon(bank_code)}`)} />
                        <div className="min-w-0">
                          <div className="pu-bank-code">{bank_code || "-"}</div>
                          <div className="pu-sub pu-mono">{maskAccount(bank_account_number) || "-"}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-7">
                      <div className="pu-kv">
                        <span className="pu-kv-label">Account Name EN</span>
                        <span className="pu-kv-value">{bank_account_name_en || "-"}</span>
                      </div>
                      <div className="pu-kv">
                        <span className="pu-kv-label">Account Name TH</span>
                        <span className="pu-kv-value">{bank_account_name_th || "-"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-outline-dark px-5 rounded-pill"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* SHARE */}
        <Modal show={modal_share} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_share: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Share</div>
              <h5 className="fw-bold mb-0">Share Transaction</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-cc-share-img mb-3">
              <img alt="share" src={share_image} width={"100%"} />
            </div>
            <label className="pr-label">Share to Group</label>
            <Select
              className="form-control"
              placeholder="Select group"
              options={global.chat_room.flatMap((group) =>
                (group?.list || []).map((chat) => ({
                  value: chat.value,
                  label: chat.label,
                }))
              )}
              value={chat_id}
              onChange={(v) => this.setState({ chat_id: v })}
            />
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer justify-content-between">
            <button
              type="button"
              className="pu-copy-btn"
              title="Download share image"
              onClick={() => {
                this.DownloadShare();
              }}
            >
              <span className="icon me-2">{""}</span>Download
            </button>
            <div className="d-flex">
              <button
                className="btn btn-dark px-4 me-1 rounded-pill"
                onClick={() => {
                  this.SubmitShare();
                }}
              >
                <span className="icon me-2">{""}</span>Share
              </button>
              <button
                className="btn btn-outline-dark px-4 ms-1 rounded-pill"
                onClick={() => {
                  this.setState({ modal_share: false });
                }}
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
